import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { clearResetPasswordError, resetPassword, useSelectResetPasswordError } from 'Auth/data';
import { useAppDispatch } from 'Store';

import type { IResetPasswordRequest } from '@libs/models';

import { ResetPasswordForm } from './ResetPasswordForm';

type Props = {
  hash: string;
};

export const ResetPasswordFormContainer = ({ hash }: Readonly<Props>) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const resetPasswordError = useSelectResetPasswordError();

  const handleSubmit = async (values: IResetPasswordRequest) => {
    const result = await dispatch(
      resetPassword({ ...values, hash } as IResetPasswordRequest)
    ).unwrap();

    if (result.shouldNavigateTo) {
      navigate(result.shouldNavigateTo, { state: result.navigationState });
    }
  };

  useEffect(() => {
    dispatch(clearResetPasswordError());
  }, [dispatch]);

  return (
    <ResetPasswordForm
      hash={hash}
      onSubmit={handleSubmit}
      error={resetPasswordError as string | null}
    />
  );
};
